module.exports = __webpack_public_path__ + "images/category_lp/car/assessment_achievements/4_edd5bbf7065bd69d42af1ff931a49e67.png";